import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo, apiSetDeflected } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import { PPUConsentScreen } from "../../CIBC/PPUConsentScreen/Index";
import { devLog } from "utils/devLog";

const policyMap = new Map();
function FIMCMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberNumber);
  const [memberNumber] = useState(props.currState.MemberLookup.memberNumber);

  const [phoneNumber] = useState(props.currState.MemberLookup.phoneNumber);

  const [firstName] = useState(props.currState.MemberLookup.firstName);
  const [lastName] = useState(props.currState.MemberLookup.lastName);

  const [stateCode] = useState(props.currState.MemberLookup.stateCode);

  const [email] = useState(props.currState.MemberLookup.email);
  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [contractData, setContractData] = useState(undefined);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);
  const [PPUReason, setPPUReason] = useState("");

  useEffect(() => {
    //devLog(props);
    onSubmit();
  }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };

  const onMemberInfo = (memberInfo) => {
    if (typeof props.onMemberInfo === "function") {
      props.onMemberInfo(memberInfo);
      // props.currState.setStates({
      //   color: memberInfo.color ? memberInfo.color : "",
      //   make: memberInfo.make ? memberInfo.make : "",
      //   model: memberInfo.model ? memberInfo.model : "",
      //   year: memberInfo.year ? memberInfo.year : "",
      // });
    }
  };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    //devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      onMemberInfo(policyMap.get(searchValue));
      setContractData(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        accountRef: props.currState.accountRef,
        searchType: searchType,
        memberNumber: memberNumber,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        state: stateCode,
        email: email,
        partnerCode: partnerCode,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        //devLog("JSON", json);
        if (json.data.PPUReason === "MNF") {
          //devLog("json.data.PPUReason", json.data.PPUReason);
          setPPUReason(json.data.PPUReason);
          setError(json.data.PPUReason);
          onLoad(false);
        } else if (typeof json.data.memberInfo === "object") {
          if (!json.data.error) {
            onMemberInfo(json.data.memberInfo);
            setContractData(json.data.memberInfo);
            setPPUReason(json.data.memberInfo.PPUReason === "EXPIRED" ? json.data.PPUReason : "");
            onLoad(true);
          } else {
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setError(t("FIMC.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })
      //Lookup: Failed
      .catch((e) => {
        //devLog("error", e);
        setLoading(false);
        setError(t("FIMC.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = (e) => {
    // e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  return (
    <>
      <div className="formContainer">
        {contractData ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.ContractInformationHeader2")}</h4>
              <hr />
              <div className="policy-info-line">
                <b>{t("FIMC.PolicyInformation.ConfirmCustomerMemberNumber")}</b>: {contractData.memberNumber}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("FIMC.PolicyInformation.ConfirmCustomerFirstName")}:</b> {contractData.firstName}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("FIMC.PolicyInformation.ConfirmCustomerLastName")}:</b> {contractData.lastName}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("FIMC.PolicyInformation.ConfirmCustomerPhoneNumber")}:</b> {contractData.phoneNumber}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("FIMC.PolicyInformation.ConfirmCustomerPostalCode")}:</b> {contractData.postalCode}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("FIMC.PolicyInformation.ConfirmCustomerEmail")}:</b>{" "}
                {contractData.email ? contractData.email : "N/A"}
              </div>
              <hr />
            </div>
          </div>
        ) : (
          <></>
        )}{" "}
      </div>
      {PPUReason && PPUReason === "MNF" ? (
        <PPUConsentScreen
          onUserBack={onUserBack}
          onUserSubmit={onSubmit}
          currState={props.currState}
          context={props.context}
          PPUReason={PPUReason}
        />
      ) : (
        <>
          {error ? (
            <div className="errorSection">
              <b className="error">{error}</b>
              <div>
                <button className="ui-btn" onClick={onUserBack}>
                  {t("description.TryAgain")}
                </button>
              </div>
            </div>
          ) : (
            <></>
          )}
        </>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleFIMC`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}

export default FIMCMemberInformationForm;
